import { Check, CheckStatus, ControlStatus } from "@oneleet/api_client";

export const ControlStatusOrder = {
  [ControlStatus.FAILING]: 1,
  [ControlStatus.NEEDS_CHANGES]: 2,
  [ControlStatus.IN_REVIEW]: 3,
  [ControlStatus.IN_PROGRESS]: 4,
  [ControlStatus.NOT_STARTED]: 5,
  [ControlStatus.PASSING]: 6,
};

export function getCheckMetrics(checks: Check[] | undefined): {
  allActiveChecksArePassing: boolean;
  inactiveChecksCount: number;
  enabledChecksCount: number;
  passingChecksCount: number;
  checksPassingPercentage: number;
} {
  if (!checks || checks.length === 0) {
    return {
      allActiveChecksArePassing: false,
      inactiveChecksCount: 0,
      enabledChecksCount: 0,
      passingChecksCount: 0,
      checksPassingPercentage: 0,
    };
  }

  const allActiveChecksArePassing = checks
    .filter((check) => check.status !== CheckStatus.INACTIVE)
    .every((check) => check.status === CheckStatus.PASSING);

  const inactiveChecksCount = checks.filter(
    (check) => check.status === CheckStatus.INACTIVE,
  ).length;

  const enabledChecksCount = checks.filter(
    (check) => check.status !== CheckStatus.INACTIVE,
  ).length;

  const passingChecksCount = checks.filter(
    (check) => check.status === CheckStatus.PASSING,
  ).length;

  const checksPassingPercentage =
    enabledChecksCount > 0
      ? (passingChecksCount / enabledChecksCount) * 100
      : 0;

  return {
    allActiveChecksArePassing,
    inactiveChecksCount,
    enabledChecksCount,
    passingChecksCount,
    checksPassingPercentage,
  };
}

export function getChecksStatus(
  allActiveChecksArePassing: boolean,
  passingChecksCount: number,
  enabledChecksCount: number,
  inactiveChecksCount: number,
) {
  return (
    <div className="flex flex-wrap items-center gap-x-2">
      <p className="text-ng-md text-neutral-600">
        {allActiveChecksArePassing ? (
          passingChecksCount === 1 ? (
            "1 check passing"
          ) : (
            `All ${passingChecksCount} checks passing`
          )
        ) : (
          <>
            {passingChecksCount} / {enabledChecksCount} checks passing
          </>
        )}
      </p>
      {inactiveChecksCount > 0 && (
        <p className="text-ng-md text-neutral-550">
          (excl. {inactiveChecksCount} inactive check
          {inactiveChecksCount > 1 && "s"})
        </p>
      )}
    </div>
  );
}
